searchUrl = "";
sitePopup = null;
  
  $(document).ready(function() {
	WishlistCount();
    OpenMiniCart();
    OpenMobileMiniCart();
    CloseMiniCart();
    CloseMobileMiniCart();
    CloseTopBar();
    CloseMobileTopBar();
    
    
    MakeSearchLink();
    ShowSubmenu();
    ShowSubmenuWhite();
    ShowSubmenuMate();
    ShowSubmenuDesk();
    FixSubmenuScroll();
    ScrollToTop();
    
    
    if ($(document).width() > 980) {
        //ShowSubscribePopUp();
    }
    
    //top slider
    $(".top-bar-home-content > div:gt(0)").hide();
    $(".top-bar-home-content > div").css({opacity:"1"});

	setInterval(function() { 
  		$('.top-bar-home-content > div:first')
    		.fadeOut(1000)
    		.next()
    		.fadeIn(1000)
    		.end()
    		.appendTo('.top-bar-home-content');
	},  5000);
  });
  
  ScrollToTop = function() {
    
    $(window).scroll(function(){
        if ($(this).scrollTop() > 200) {
            $('.back-to-top').fadeIn();
        } else {
            $('.back-to-top').fadeOut();
        }
    });

    //Click event to scroll to top
    $('.back-to-top').click(function(){
        $('html, body').animate({scrollTop : 0},1500);
        return false;
    });
    
    
    
    
    
  }

  ShowSubmenu = function() {
    $(".has_sub_menu").hover(function(){
      $('.submenu-container').show();
    },function(){
      $('.submenu-container').hide();
    });
  }
  
  ShowSubmenuWhite = function() {
    $(".has_sub_menu.white").hover(function(){
      $('.submenu-white').show();
    },function(){
      $('.submenu-white').hide();
    });
  }
  
  ShowSubmenuMate = function() {
    $(".has_sub_menu.mate").hover(function(){
      $('.submenu-mate').show();
    },function(){
      $('.submenu-mate').hide();
    });
  }
  
  ShowSubmenuDesk = function() {
    $(".sub_menu_cloting").hover(function(){
      $('.submenu-container-cloting').show();
    },function(){
      $('.submenu-container-cloting').hide();
    });
  }
  
  
  FixSubmenuScroll = function() {
    $(window).scroll(function() {
      var scrollTop = $(window).scrollTop();
      if ( scrollTop > 0 ) { 
        $('.submenu-container').css('position', 'fixed');
        $('.submenu-container').css('top', '6px');
      } else {
        $('.submenu-container').css('position', 'unset');
      }
    });
  }
  
  MakeSearchLink = function() {
    $('#theTopSearch').on('keyup', function() {
    	$(".search-url").attr("href", "/pages/search-results?s=" + $('#theTopSearch').val());
    });
  } 
  
  ShowSubscribePopUp = function() {
    sitePopup = new SBTDPopup('SBTD_Popup_Box');
    $('.show-popup').on('click', function() {sitePopup.showPopup(); });
    $('#stickyButtonPopup').on('click', function() {sitePopup.showPopup(); });
    
  }

  
  WishlistCount = function () {
    
    var url = 'https://app.savedbythedress.net/wishlist/get/' + theCustomerId;
    if (theCustomerId !== "" && theCustomerId > 1) {
      $.ajax({
        type: "GET",
        url: url,
        success: WishlistCountCallback,
        error: function(data){
        }
      });
    } 
  };

  WishlistCountCallback = function (response) {
    if (typeof response.data.items == 'string') {
      	$('.wishlist-count').html('');
    } else {
      	var count = response.data.items.length;
    	$('.wishlist-count').html(count);
    }
    
  }
  
  OpenMiniCart = function () {
    $(".open-mini-cart").on("click", function(){
      if ($(".mini-cart").css('display') == 'none') {
      	$(".mini-cart").show("fast");
      } else {
        $(".mini-cart").hide("fast");
      }
    });
  }
  
  CloseMiniCart = function () {
    $(".close-mini-cart").on("click", function(){
       $(".mini-cart").hide("fast");
    });
  }
  
  OpenMobileMiniCart = function () {
    $(".open-mobile-mini-cart").on("click", function(){
      if ($(".mobile-mini-cart").css('display') == 'none') {
        $('html, body').animate({
          scrollTop: 0
        }, 500);
      	$(".mobile-mini-cart").show("fast");
        
      } else {
        $('html, body').animate({
          scrollTop: 0
        }, 500);
        // $(".mobile-mini-cart").hide("fast");
      }
    });
  }
  
  CloseMobileMiniCart = function () {
    $(".close-mobile-mini-cart").on("click", function(){
       $(".mobile-mini-cart").hide("fast");
    });
  }
  
  CloseTopBar = function() {
  	$(".close-top-bar").on("click", function(){
       $(".top-bar").hide("fast");
      });
  }
  
  CloseMobileTopBar = function() {
  	$(".close-mobile-top-bar").on("click", function(){
       $(".mobile-top-bar").hide("fast");
      });
  }
  
